import React from 'react';
import { movdTokens } from '../design-system/movdTokens.js';

const stages = ['Build', 'Details', 'Movers', 'Booking', 'Confirm'];

export default function ProgressStepper({ currentStep = 0 }) {
  return (
    <nav aria-label="Move journey" style={{ display: 'grid', gridTemplateColumns: `repeat(${stages.length}, minmax(0, 1fr))`, gap: 8, maxWidth: 760, margin: '0 auto' }}>
      {stages.map((stage, index) => {
        const active = index === currentStep;
        const complete = index < currentStep;
        return <div key={stage} style={{ minWidth: 0 }}>
          <div style={{ height: 4, background: complete || active ? movdTokens.color.brand.primary : movdTokens.color.surface.muted, transition: `background ${movdTokens.motion.standard}` }} />
          <div style={{ marginTop: movdTokens.space[2], color: active ? movdTokens.color.content.primary : complete ? movdTokens.color.brand.primary : movdTokens.color.content.muted, fontSize: movdTokens.typography.size.xs, fontWeight: active ? movdTokens.typography.weight.black : movdTokens.typography.weight.semibold, letterSpacing: '.12em', overflow: 'hidden', textOverflow: 'ellipsis', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{stage}</div>
        </div>;
      })}
    </nav>
  );
}
